var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "default-btn-styling",
      class: {
        "btn-height-large": _vm.size === "large",
        "btn-hover": _vm.buttonColor === "#128279"
      },
      style: { background: _vm.buttonColor, color: _vm.fontColor },
      attrs: {
        elevation: "0",
        disabled: _vm.rightBtnDisabled,
        outlined: _vm.outlined
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }